import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, Injector, Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { debounceTime, tap } from 'rxjs/operators';
import { EventManagerService } from '../service/event-manager.service';
import { SubscriptionService } from '../service/subscription.service';

@Injectable({ providedIn: 'any' })
export abstract class EditComponent implements OnInit, OnDestroy {
  @Input() queryParams: any = {};
  @Input() id: any;
  @Input() detailObject: any = {};
  errors: any = {};
  isSaved: boolean = false;
  isUpload: boolean = false;
  subscriptions?: Subscription[] = [];
  subsCommon?: Subscription[] = [];
  callApi$ = new Subject();
  editForm: any;
  subscribeState: any;
  constructor(
    public eventManager: EventManagerService,
    public route: ActivatedRoute
  ) {
  }
  ngOnInit() {
    this.subscribeState = SubscriptionService.register(2, this.parseData.bind(this));
    const params = this.route.snapshot.params;
    this.id = this.id || params.id;
    if (this.id) {
      this.getDetail();
    }
    this.subsCommon =[
      this.eventManager.subscribe('upload-file', (res) => {
        this.isUpload = true;
      }),
      this.eventManager.subscribe('upload-fail', (res) => {
        this.isUpload = true;
      }),
    ];
    this.callApi$.pipe(
      debounceTime(500),
      ).subscribe((event)=> { return this.callAPI(event);});
  }
  ngOnDestroy() {
    if (this.subscriptions.length > 0) {
      this.eventManager.destroys(this.subscriptions);
    }
    this.eventManager.destroys(this.subsCommon);
  }
  getDetail() {}
  parseData() {}
  onSuccess(res) {}
  onError(error) {}
  updateForm() {}
  disabledButton() {
    const keys = Object.keys(this.errors);
    const key = keys.find(key => this.errors[key]);
    return key ? true : false;
  }
  callAPI(event?) {
  }
  executeCallAPI(event?) {
    this.callApi$.next(event || true);
  }
  patchValue(key, value) {
    this.editForm.patchValue({
      [key]: value
    })
  }
  beforeSave() {
    this.isSaved =  true;
    const values = this.editForm.value;
    Object.keys(values).forEach((key) => {
      if (values[key] === 'undefined') {
        const object = {};
        object[key] = undefined;
        this.editForm.patchValue(object);
      }
    })
    const result = this.disabledButton();
    if (result || this.editForm.invalid) {
      return true;
    }
  }
  save() {
    if (this.beforeSave()) {
      return;
    }
  }
}
